import React from "react";
import './AgriConnect.css';
import brochure from './media/agri-connect-broschuere.pdf';

const AgriConnect = () => {
    return (
        <div className="agriconnect-section">
            <div className="agriconnect-header">
                <span className="label-sub">Unser Partner in Tansania</span>
                <h1>Agri-Connect Tanzania</h1>
            </div>

            <div className="agriconnect-body">
                <p>
                    Agri-Connect Tanzania ist eine registrierte Nichtregierungsorganisation (NGO) in der
                    Kilimanjaro-Region Tansanias, gegründet von der Gospelsängerin und Sozialunternehmerin
                    Agnes Link. Ihr Leitgedanke „Support people in need to support themselves" – Menschen in
                    Not dabei helfen, sich selbst zu helfen – ist zugleich der Kern unserer Partnerschaft mit
                    Afrika-Link.
                </p>
                <p>
                    Viele junge Menschen in Tansania kämpfen mit Arbeitslosigkeit, fehlenden Perspektiven und
                    den Folgen von Landflucht und Suchtproblemen. Agri-Connect Tanzania setzt genau hier an
                    und begleitet Jugendliche in einem dreistufigen Modell – von der Veränderung der eigenen
                    Denkweise (Kijana Kujiwezesha), über das gegenseitige Unterstützen in Gruppen (Vijana
                    Kuwezeshana), bis hin zur konkreten materiellen Förderung (Vijana Kuwezeshwa).
                </p>
                <p>
                    Konkret bedeutet das: Seminare, Workshops und Gruppentreffen zur Persönlichkeitsentwicklung
                    und zum Kompetenzaufbau, sowie ein Mikrokredit-Programm, das jungen Menschen Startkapital
                    für eigene kleine Landwirtschafts- und Geschäftsprojekte zur Verfügung stellt. Ziel ist es,
                    gezielt auch jene zu erreichen, die bisher kaum Zugang zu Unterstützung hatten – Jugendliche
                    in entlegenen Dörfern ebenso wie junge Menschen, die bereits in schwierigen Lebenslagen
                    stecken.
                </p>
                <p>
                    Afrika-Link unterstützt die Arbeit von Agri-Connect Tanzania, um jungen Menschen in
                    Tansania eine echte Bleibeperspektive zu geben – durch Hilfe zur Selbsthilfe statt durch
                    reine Almosen.
                </p>
            </div>

            <a
                className="agriconnect-preview-card"
                href="https://agneslink.international/agri-connect-tanzania/"
                target="_blank"
                rel="noreferrer noopener"
            >
                <div className="agriconnect-preview-badge">AC</div>
                <div className="agriconnect-preview-content">
                    <span className="agriconnect-preview-eyebrow">agneslink.international</span>
                    <h3>Agri-Connect Tanzania</h3>
                    <p>„Support people in need to support themselves" — mehr über das Projekt, Agnes Link und
                        aktuelle Neuigkeiten auf der offiziellen Website.</p>
                    <span className="agriconnect-preview-cta">Website besuchen ↗</span>
                </div>
            </a>

            <div className="agriconnect-brochure-card">
                <div className="agriconnect-brochure-text">
                    <h3>Agri-Connect Broschüre</h3>
                    <p>Alle Informationen zu Agri-Connect Tanzania kompakt zum Nachlesen und Weitergeben.</p>
                </div>
                {brochure
                    ? (
                        <a className="agriconnect-brochure-button" href={brochure} target="_blank" rel="noreferrer">
                            Broschüre herunterladen
                        </a>
                    )
                    : (
                        <span className="agriconnect-brochure-button agriconnect-brochure-button--disabled">
                            Broschüre folgt in Kürze
                        </span>
                    )
                }
            </div>
        </div>
    );
};

export default AgriConnect;
